import { render, staticRenderFns } from "./BrandCollections.vue?vue&type=template&id=43b6e566&"
import script from "./BrandCollections.vue?vue&type=script&lang=js&"
export * from "./BrandCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports